import { Table } from "@/features/Table";
import { type C8Transaction, porfolios_columns } from "./columns";
import {
  type FilterC8TransactionsSchema,
  FilterC8Transactions,
} from "./filter";

const client = "c8";
const table_name = "c8_transactions";

export const C8TransactionsTable = () => {
  return (
    <Table<C8Transaction, FilterC8TransactionsSchema>
      label="Transactions"
      client={client}
      table_name={table_name}
      columns={porfolios_columns}
      filter={<FilterC8Transactions />}
      actions={[
        {
          label: "actions.new",
          route: `c8/${table_name}/new`,
        },
      ]}
    />
  );
};
